export default __webpack_public_path__ + "static/date-label-anatomy-dark-170aed6a795bbeb9d9f4303d11cf27c64ebd69f36a1ac0eac9c60855a6f468f8.png";